<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_265_12236)">
        <path d="M12.7168 1.00189V23.0433" stroke="currentColor" stroke-width="2" stroke-linecap="round"
            stroke-linejoin="round" />
        <path
            d="M17.7263 5.0094H10.2121C9.28215 5.0094 8.39023 5.37884 7.73262 6.03645C7.07501 6.69407 6.70557 7.58598 6.70557 8.51598C6.70557 9.44599 7.07501 10.3379 7.73262 10.9955C8.39023 11.6531 9.28215 12.0226 10.2121 12.0226H15.2216C16.1516 12.0226 17.0435 12.392 17.7011 13.0496C18.3587 13.7072 18.7281 14.5991 18.7281 15.5291C18.7281 16.4592 18.3587 17.3511 17.7011 18.0087C17.0435 18.6663 16.1516 19.0357 15.2216 19.0357H6.70557"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </g>
    <defs>
        <clipPath id="clip0_265_12236">
            <rect width="24.0451" height="24.0451" fill="white" transform="translate(0.694336)" />
        </clipPath>
    </defs>
</svg>